import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";

import TableContainer from "@material-ui/core/TableContainer";
import {  Link } from "react-router-dom";
import {
  
  Table,
  
} from "reactstrap";
import { Card, CardTitle } from "reactstrap";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import base_URL from "../base_URL";
import { Container } from "@material-ui/core";

class Profile extends Component {


  constructor(props) {
    super(props);
   
    const p1 = JSON.parse(localStorage.getItem("token"));
    this.state = {
      p: p1,
      userService: [],
    };

    this.loadService = this.loadService.bind(this);
    this.deleteUserService = this.deleteUserService.bind(this);
  }

  deleteUserService = async (id) => {
    await Axios.delete(`${base_URL}/Service/del/${id}`);
    this.loadService();
  };

  loadService = async () => {
    const p = this.state.p.id;
    await Axios.get(`${base_URL}/Service/user`, {
      params: {
        id: p,
      },
    }).then((response) => {
      this.setState({
        userService: response.data.reverse(),
      });
    });
  };

  componentDidMount() {
   
    if (localStorage.getItem("token") == null) return <Redirect to="/login" />;
    this.loadService();
  }

  render() {
    if (localStorage.getItem("token") == null) return <Redirect to="/login" />;

    const p = JSON.parse(localStorage.getItem("token"));
    return (
      <Container  id="container">
        <Card body style={{ margin: "20px" }} id="Card">
          <CardTitle>
            <h1>My Profile</h1>
          </CardTitle>

          <div class="form-group">
            <label for="name">Name:</label>
            <input
              type="text"
              name="name"
              readOnly
              value={p.firstName + " " + p.lastName}
              class="form-control"
              placeholder="Enter name"
              id="name"
            />
          </div>

          <div class="form-group">
            <label for="name">Email:</label>
            <input
              type="text"
              name="name"
              readOnly
              value={p.email.toLowerCase()}
              class="form-control"
              placeholder="Enter name"
              id="name"
            />
          </div>
        </Card>

        <Paper>
          <TableContainer style={{ maxHeight: 500 }}>
            <Table responsive className="table border shadow">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Theme</th>
                  <th scope="col">Contact Person</th>
                  <th scope="col">Contact Details</th>
                  <th scope="col">State</th>
                  <th scope="col">City</th>
                  <th scope="col">Other Details</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.userService.map((user, index) => (
                  <tr>
                    <th scope="row">{index + 1}</th>
                    <td>{user.theme}</td>
                    <td>{user.name}</td>
                    <td>{user.phone}</td>
                    <td>{user.state}</td>
                    <td>{user.city}</td>
                    <td>{user.comment}</td>
                    <td>
                     
                      <Link
                        type="button"
                        class="btn btn-danger"
                        onClick={() => this.deleteUserService(user.id)}
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </Paper>
      </Container>
    );
  }
}

Profile.propTypes = {};

export default Profile;
